import { BuilderType, projectsCacheTags } from './projectsApiHelpers';
export type Survey = {
  id: number;
  title: string;
  comments_label: string;
};

export type SurveyAnswer = {
  id: number;
  rating: number;
  comments: string;
  contact_me: boolean;
};
export const surveysApi = (builder: BuilderType) => ({
  getSurveys: builder.query<Survey[], void>({
    query: () => `/service/surveys/unanswered`,
    providesTags: [projectsCacheTags.SURVEYS],
  }),

  updateSurvey: builder.mutation<SurveyAnswer, SurveyAnswer>({
    query: (body) => ({
      url: `/service/surveys/${body.id}/answer`,
      method: 'POST',
      body,
    }),
    invalidatesTags: [projectsCacheTags.SURVEYS],
  }),
});
